import { mapState } from 'vuex';

const SkinMixin = {
  computed: {
    ...mapState('common', [
      'duelSkin',
    ]),
  },
  methods: {
    $_skinImage({ fileName, skins = [] }) {
      return skins.includes(this.duelSkin)
        ? `static/skins/skin_${this.duelSkin}/images/${fileName}`
        : `static/images/${fileName}`;
    },
  },
};

export default SkinMixin;



// WEBPACK FOOTER //
// ./src/common/mixins/skin.js